/*
 * @Author: Bohemian-hub dongshangwl@gmail.com
 * @Date: 2024-05-13 10:42:59
 * @LastEditors: Bohemian-hub dongshangwl@gmail.com
 * @LastEditTime: 2024-06-16 14:47:24
 * @FilePath: \kegel_manage\vue-manage-system-plus\src\common\config\index.js
 * @Description:
 */
/**
 * 存放一些常用的公共配置
 * @description 暂时提供： appid、接口前缀
 * @Author lss
 * @Date 2021-3-9
 */

export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:5000' : '/api'
